import { render } from "./PlayNoticeModal.vue?vue&type=template&id=11df736e&scoped=true"
import script from "./PlayNoticeModal.vue?vue&type=script&lang=js"
export * from "./PlayNoticeModal.vue?vue&type=script&lang=js"

import "./PlayNoticeModal.vue?vue&type=style&index=0&id=11df736e&scoped=true&lang=css"

import exportComponent from "/var/www/mobitel/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11df736e"]])

export default __exports__